import PassThroughVue from "@/components/layouts/PassThrough.vue";
import { ACCOUNT_TYPES } from "@/constants";
import { COMPANY_ROUTER_NAMES } from "./routesNames";

const companyRouters =
{
  path: "/company",
  name: "company_pages",
  component: PassThroughVue,
  children: [
    {
      path: "",
      name: COMPANY_ROUTER_NAMES.login,
      meta: {
        anonymousOnly: true,
        redirect: COMPANY_ROUTER_NAMES.home,
      },
      component: () =>
        import(/* webpackChunkName: "s901" */ "@/views/auth/ViewS901.vue"),
    },
    {
      path: "home",
      name: COMPANY_ROUTER_NAMES.home,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s911" */ "@/views/admin/ViewS800.vue"),
    },
    {
      path: "store/list",
      name: COMPANY_ROUTER_NAMES.listStore,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s801" */ "@/views/admin/ViewS801.vue"),
    },
    {
      path: "store/create",
      name: COMPANY_ROUTER_NAMES.createStore,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s802" */ "@/views/admin/ViewS802.vue"),
    },
    {
      path: "store/:id",
      name: COMPANY_ROUTER_NAMES.detailStore,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s802" */ "@/views/admin/ViewS802-1.vue"),
    },
    {
      path: "store-group",
      name: COMPANY_ROUTER_NAMES.storeGroup,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s803" */ "@/views/admin/ViewS803.vue"),
    },
    {
      path: "permission/list",
      name: COMPANY_ROUTER_NAMES.listPermission,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s811" */ "@/views/admin/ViewS811.vue"),
    },
    {
      path: "permission/:id",
      name: COMPANY_ROUTER_NAMES.detailPermission,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s812" */ "@/views/admin/ViewS812.vue"),
    },
    {
      path: "staff",
      name: COMPANY_ROUTER_NAMES.staffRegistrationDetail,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s813" */ "@/views/admin/ViewS813.vue"),
    },
    {
      path: "change-registered-information",
      name: COMPANY_ROUTER_NAMES.changeRegisteredInformation,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s821" */ "@/views/admin/ViewS821.vue"),
    },
    {
      path: "plan",
      name: COMPANY_ROUTER_NAMES.companyPlan,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "ViewPlan" */ "@/views/admin/ViewPlan.vue"),
    },
    {
      path: "account-setting",
      name: COMPANY_ROUTER_NAMES.accountSetting,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF],
      },
      component: () =>
        import(/* webpackChunkName: "s822" */ "@/views/admin/ViewS822.vue"),
    },
    {
      path: "change-password",
      name: COMPANY_ROUTER_NAMES.changePassword,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF, ACCOUNT_TYPES.STORE],
      },
      component: () =>
        import(/* webpackChunkName: "s823" */ "@/views/admin/ViewS823.vue"),
    },
    {
      path: "change-email",
      name: COMPANY_ROUTER_NAMES.changeEmail,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER, ACCOUNT_TYPES.COMPANY_STAFF, ACCOUNT_TYPES.STORE],
      },
      component: () =>
        import(/* webpackChunkName: "s824" */ "@/views/admin/ViewS824.vue"),
    },
    {
      path: "register-bag",
      name: COMPANY_ROUTER_NAMES.registerBag,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s717" */ "@/views/admin/ViewS717.vue"),
    },
    {
      path: "category/list",
      name: COMPANY_ROUTER_NAMES.listCategory,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s701" */ "@/views/admin/ViewS701.vue"),
    },
    {
      path: "category/:id",
      name: COMPANY_ROUTER_NAMES.detailCategory,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s703" */ "@/views/admin/ViewS703.vue"),
    },
    {
      path: "product/list",
      name: COMPANY_ROUTER_NAMES.listProduct,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s711" */ "@/views/admin/ViewS711.vue"),
    },
    {
      path: "product/create",
      name: COMPANY_ROUTER_NAMES.createProduct,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s712-1" */ "@/views/admin/ViewS712-1.vue"),
    },
    {
      path: "product/:id",
      name: COMPANY_ROUTER_NAMES.detailProduct,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s712-1" */ "@/views/admin/ViewS712-2.vue"),
    },
    {
      path: "set-product/list",
      name: COMPANY_ROUTER_NAMES.listSetProduct,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s721" */ "@/views/admin/ViewS721.vue"),
    },
    {
      path: "set-product/:id",
      name: COMPANY_ROUTER_NAMES.detailSetProduct,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s722" */ "@/views/admin/ViewS722.vue"),
    },
    {
      path: "bundle-product/list",
      name: COMPANY_ROUTER_NAMES.listBundleProduct,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s725" */ "@/views/admin/ViewS725.vue"),
    },
    {
      path: "bundle-product/:id",
      name: COMPANY_ROUTER_NAMES.detailBundleProduct,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s726" */ "@/views/admin/ViewS726.vue"),
    },
    {
      path: "payment-classification-setting",
      name: COMPANY_ROUTER_NAMES.paymentTypeSetting,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s761" */ "@/views/admin/ViewS761.vue"),
    },
    {
      path: "payment-method-setting",
      name: COMPANY_ROUTER_NAMES.paymentMethodSetting,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s762" */ "@/views/admin/ViewS762.vue"),
    },
    {
      path: "deposit-category-registration",
      name: COMPANY_ROUTER_NAMES.depositCategoryRegistration,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s771" */ "@/views/admin/ViewS771.vue"),
    },
    {
      path: "withdrawal-classification-registration",
      name: COMPANY_ROUTER_NAMES.withdrawalClassificationRegistration,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s772" */ "@/views/admin/ViewS772.vue"),
    },
    {
      path: "receipt-setting",
      name: COMPANY_ROUTER_NAMES.receiptSetting,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s782" */ "@/views/admin/ViewS782.vue"),
    },
    {
      path: "master-setting",
      name: COMPANY_ROUTER_NAMES.masterSetting,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s783" */ "@/views/admin/ViewS783.vue"),
    },
    {
      path: "sale-setting",
      name: COMPANY_ROUTER_NAMES.saleSetting,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s731" */ "@/views/admin/ViewS731.vue"),
    },
    {
      path: "sale-setting/detail",
      name: COMPANY_ROUTER_NAMES.saleDetailsSetting,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s732" */ "@/views/admin/ViewS732.vue"),
    },
    {
      path: "sale-setting/detail-modal",
      name: COMPANY_ROUTER_NAMES.saleDetailsSettingModal,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s732" */ "@/views/admin/ViewS733.vue"),
    },
    {
      path: "coupon-setting",
      name: COMPANY_ROUTER_NAMES.couponSetting,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s741" */ "@/views/admin/ViewS741.vue"),
    },
    {
      path: "add-coupon",
      name: COMPANY_ROUTER_NAMES.addCoupon,
      meta: {
        requiresAuth: true,
        redirect: COMPANY_ROUTER_NAMES.login,
        accountTypes: [ACCOUNT_TYPES.COMPANY_MANAGER],
      },
      component: () =>
        import(/* webpackChunkName: "s742" */ "@/views/admin/ViewS742.vue"),
    },
  ],
};

export { companyRouters, COMPANY_ROUTER_NAMES };
